import { IGetProfessionalCountsParams } from '../types/IGetProfessionalCountsParams';
import { IProfessionalCountsResponse } from '../types/IProfessionalCountsResponse';
import { GetProfessionalCountsClient } from '../clients/GetProfessionalCounts';

export const ProfessionalsService = {
  getProfessionalCountsByOffice: (
    params: IGetProfessionalCountsParams,
  ): Promise<IProfessionalCountsResponse> =>
    GetProfessionalCountsClient.getProfessionalCountsByOffice(params),
};
